import type { FormKitNode } from '@formkit/core'
import { phone as phoneFn } from 'phone'

export default (node: FormKitNode): boolean => {
  const phonePrefix = node.props.attrs['data-phone-prefix'] ?? ''
  const fullPhoneNumber = `+${phonePrefix}${node.value}`
  const phoneValidation = phoneFn(fullPhoneNumber, { strictDetection: true })

  return phoneValidation.isValid
}
